import { useMemo, useState } from "react";
import { getSocieties, getSocietySelected } from "@icarius-pages/login/selectors";
import { useDispatch, useSelector } from "react-redux";
import { selectSociety } from "@icarius-pages/login/actions";
import { useHistory } from "react-router-dom";

const useChangeSociety = () => {

  const [changeSocietyDialogIsOpen, setChangeSocietyDialogIsOpen] = useState(false);

  const societySelected = useSelector(getSocietySelected);
  const societies = useSelector(getSocieties);

  const dispatch = useDispatch();
  const history = useHistory();

  const societyOptions = useMemo(() => {
    return societies.map(society => ({
      ...society,
      key: society.number,
      value: society.name,
    }))
  }, [societies])

  const canChangeSociety = societyOptions?.length > 1;

  const handleChangeSociety = (societyDbName) => {
    const newSociety = societies.find((society) => society.number === societyDbName);

    setChangeSocietyDialogIsOpen(false);
    dispatch(selectSociety(newSociety));
    history.push('/');
  }

  const handleOpenChangeSocietyDialog = () => {
    setChangeSocietyDialogIsOpen(true);
  }

  const handleCloseChangeSocietyDialog = () => {
    setChangeSocietyDialogIsOpen(false);
  }

  return {
    canChangeSociety,
    societySelected,
    societyOptions,
    changeSocietyDialogIsOpen,
    handleChangeSociety,
    handleOpenChangeSocietyDialog,
    handleCloseChangeSocietyDialog,
  }
}

export default useChangeSociety;